(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartDrawerSection {
    constructor(section) {
      this.section = section;
      this.el = section.el;
      this.drawer = this.el.querySelector('#cart-drawer');
      this.overlay = this.el.querySelector('#cart-drawer-overlay');

      this.drawer.dataset.animationState = 'closed';
      this.overlay.dataset.animationState = 'closed';

      this.events = new window.Empire.EventHandler.Z();
      this.controller = new AbortController();
      this.isOpen = false;
      this.isAnimating = false;
      this.lastFocus = null;

      this._onDrawerKeydown = this._onDrawerKeydown.bind(this);
      this._onDrawerTransitionEnd = this._onDrawerTransitionEnd.bind(this);

      this._bindStatic();
      this.installAddIntercept();
      this._bindInner();
      this._syncMinusDisabled(this.drawer);
    }

    // ---------- Public API ----------
    open() {
      if (this.isOpen || this.isAnimating) return;
      this.isOpen = true;
      this.isAnimating = true;
      this.lastFocus = document.activeElement;

      document.documentElement.classList.add('cart-drawer-open');

      this.overlay.dataset.animationState = 'open';
      this.drawer.dataset.animationState = 'open';

      // Focus after the browser applies styles
      requestAnimationFrame(() => {
        this.drawer.focus();
        this._trapFocus(true);
      });

      this._armTransitionEnd();
    }

    close() {
      if (!this.isOpen || this.isAnimating) return;
      this.isOpen = false;
      this.isAnimating = true;

      document.documentElement.classList.remove('cart-drawer-open');

      // Animate out (keep visibility: visible during the animation)
      this.overlay.dataset.animationState = 'closing';
      this.drawer.dataset.animationState = 'closing';

      this._trapFocus(false);

      // Wait for slide-out end to actually hide
      this._armTransitionEnd();
    }

    async refresh() {
      const sectionId = this._getSectionId();
      const html = await this._fetchSectionHTML(sectionId);
      await this._renderDrawerFromHTML(html);
    }

    onSectionUnload() {
      this.controller.abort();
      this.events.unregisterAll();
      this.drawer.removeEventListener('transitionend', this._onDrawerTransitionEnd);
      document.removeEventListener('keydown', this.onDocKey, true);
      document.removeEventListener('click', this.onDocClickCapture, true);
    }

    // ---------- Internals ----------
    _bindStatic() {
      // Close by clicking overlay
      this.events.register(this.overlay, 'click', () => this.close());

      // Open triggers
      this.events.register(document, 'click', (e) => {
        const trigger = e.target.closest('[data-open-cart-drawer]');
        if (!trigger) return;
        e.preventDefault();
        this.open();
      });

      // Close on escape
      this.events.register(
        document,
        'keydown',
        (e) => {
          if (e.key !== 'Escape') return;
          if (!this.isOpen) return;
          e.preventDefault();
          this.close();
        },
        { capture: true }
      );
    }

    // Inner listeners need to be rebound after content refresh
    _bindInner() {
      // Close buttons
      const closeBtns = this.drawer.querySelectorAll('[data-cart-drawer-close]');
      if (closeBtns.length) {
        closeBtns.forEach((closeBtn) => {
          this.events.register(closeBtn, 'click', () => this.close());
        });
      }

      const list = this.drawer.querySelector('.cartitems--list');
      if (!list) return;

      // Remove
      this.events.register(list, 'click', (e) => {
        const removeLink = e.target.closest('[data-cartitem-remove]');
        if (!removeLink) return;
        e.preventDefault();
        const key = this._getLineKeyFromChild(removeLink);
        if (!key) return;
        this._updateLine(key, 0);
      });

      // Plus / Minus
      this.events.register(list, 'click', (e) => {
        const plus = e.target.closest('[data-quantity-plus]');
        const minus = e.target.closest('[data-quantity-minus]');
        if (!plus && !minus) return;

        const itemEl = e.target.closest('[data-cartitem-key]');
        if (!itemEl) return;

        const key = itemEl.dataset.cartitemKey;
        const input = itemEl.querySelector('[data-quantity-input]');
        if (!key || !input) return;

        const step = parseInt(input.dataset.incrementValue || '1', 10) || 1;
        const current = Math.max(0, parseInt(input.value, 10) || 0);
        const next = plus ? current + step : Math.max(0, current - step);

        input.value = next;
        this._updateLine(key, next);
      });

      // Input change
      this.events.register(list, 'change', (e) => {
        if (!e.target.matches('[data-quantity-input]')) return;
        const itemEl = e.target.closest('[data-cartitem-key]');
        const key = itemEl?.dataset.cartitemKey;
        if (!key) return;

        const val = Math.max(0, parseInt(e.target.value, 10) || 0);
        this._updateLine(key, val);
      });
    }

    _armTransitionEnd() {
      this.drawer.removeEventListener('transitionend', this._onDrawerTransitionEnd);
      this.drawer.addEventListener('transitionend', this._onDrawerTransitionEnd);
    }

    _onDrawerTransitionEnd(e) {
      if (e.propertyName !== 'transform') return;

      if (this.isOpen) {
        this.overlay.dataset.animationState = 'open';
        this.isAnimating = false;
        return;
      }

      this.drawer.dataset.animationState = 'closed';
      this.overlay.dataset.animationState = 'closed';
      this.isAnimating = false;

      if (this.lastFocus) this.lastFocus.focus();
    }

    _trapFocus(enable) {
      if (enable) {
        this.drawer.addEventListener('keydown', this._onDrawerKeydown);
        this.drawer.setAttribute('aria-hidden', 'false');
        this.drawer.inert = false;
      } else {
        this.drawer.removeEventListener('keydown', this._onDrawerKeydown);
        this.drawer.setAttribute('aria-hidden', 'true');
        this.drawer.inert = true;
      }
    }

    _onDrawerKeydown(e) {
      if (e.key !== 'Tab') return;
      const focusable = this.drawer.querySelectorAll(
        'a,button,[href],[tabindex]:not([tabindex="-1"]),input,select,textarea'
      );
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    _syncMinusDisabled(el) {
      el.querySelectorAll('[data-cartitem-key]').forEach((itemEl) => {
        const input = itemEl.querySelector('[data-quantity-input]');
        const wrapMinus = itemEl.querySelector('[data-button-wrapper-minus]');
        if (!input || !wrapMinus) return;
        const step = parseInt(input.dataset.incrementValue || '1', 10) || 1;
        const qty = Math.max(0, parseInt(input.value, 10) || 0);
        wrapMinus.classList.toggle('quantity-selector__button-wrapper--disabled', qty <= step);
      });
    }

    _setQtyControlsEnabled(enabled) {
      if (!this.drawer) return;
      const controls = this.drawer.querySelectorAll(
        '[data-quantity-input], [data-quantity-plus], [data-quantity-minus]'
      );

      controls.forEach((el) => {
        const tag = el.tagName;
        const isFormCtrl = tag === 'INPUT' || tag === 'BUTTON';

        if (enabled) {
          el.removeAttribute('disabled');
          el.removeAttribute('readonly');
          el.removeAttribute('aria-busy');
        } else {
          // Disable
          el.setAttribute('disabled', '');
          el.setAttribute('readonly', '');
          el.setAttribute('aria-busy', 'true');
        }
      });
    }

    async _updateLine(key, quantity) {
      const sectionId = this._getSectionId();
      const signal = this.controller.signal;

      this._setQtyControlsEnabled(false);

      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: key,
            quantity,
            sections: [sectionId],
            sections_url: window.location.pathname,
          }),
          signal,
        });

        const json = await res.json();

        if (!res.ok) {
          const msg = json.description || json.message || 'Unable to update quantity.';
          new window.Empire.MessageBanner(msg, 'error');

          // On a 422 error, the QTY may have changed, so we continue to refresh
          if (res.status !== 422) {
            return;
          }
        }

        if (json.sections && json.sections[sectionId]) {
          await this._renderDrawerFromHTML(json.sections[sectionId]);
        } else {
          await this.refresh();
        }

        const cart = await fetch(`${window.Empire.routes.cart_url}.js`, { signal }).then((r) => r.json());
        window.dispatchEvent(new CustomEvent('cartcount:update', { detail: cart }));
      } catch (err) {
        if (err.name === 'AbortError') return;
        console.error('[CartDrawer] line update error', err);
        new window.Empire.MessageBanner('Something went wrong. Please try again.', 'error');
      } finally {
        this._setQtyControlsEnabled(true);
        this._syncMinusDisabled(this.drawer);
      }
    }

    async _renderDrawerFromHTML(html) {
      const tmp = document.createElement('div');
      tmp.innerHTML = html;

      // Sync minus button states prior to render
      this._syncMinusDisabled(tmp);

      const next = tmp.querySelector('#cart-drawer-content');
      if (!next) return;

      // Keep scroll position
      const scroller = this.drawer.querySelector('#cart-drawer-line-items');
      const prevTop = scroller ? scroller.scrollTop : 0;
      const prevHeight = scroller ? scroller.scrollHeight : 0;
      const prevClient = scroller ? scroller.clientHeight : 0;

      // Lock height briefly to reduce layout jump from late-loading images
      if (scroller) scroller.style.minHeight = `${prevClient}px`;

      const current = this.drawer.querySelector('#cart-drawer-content');
      if (current) current.replaceWith(next);
      else this.drawer.appendChild(next);

      // Re-bind inner listeners after DOM swap
      this._bindInner();

      // Restore scroll (ratio-based for changed heights)
      requestAnimationFrame(() => {
        const newScroller = this.drawer.querySelector('#cart-drawer-line-items');
        if (newScroller) {
          const newHeight = newScroller.scrollHeight || 1;
          const ratio = prevHeight ? prevTop / prevHeight : 0;
          newScroller.scrollTop = Math.round(ratio * newHeight);
          newScroller.style.minHeight = ''; // unlock
        }
      });
    }

    async _fetchSectionHTML(sectionId) {
      const url = new URL(window.location.href);
      url.searchParams.set('sections', sectionId);
      const res = await fetch(url.toString(), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        signal: this.controller.signal,
      });
      const json = await res.json();
      return json[sectionId];
    }

    _getSectionId() {
      return this.drawer?.dataset?.sectionId;
    }

    _getLineKeyFromChild(el) {
      const li = el.closest('[data-cartitem-key]');
      return li ? li.dataset.cartitemKey : null;
    }

    _isProductAddForm(form) {
      if (!form || !form.matches) return false;
      if (!form.matches('form[data-product-form]')) return false;
      const action = (form.getAttribute('action') || '').toLowerCase();
      if (!/\/cart\/add(?:\.js)?/.test(action)) return false;
      if (form.hasAttribute('data-no-ajax-cart')) return false; // opt-out
      return true;
    }

    installAddIntercept() {
      if (this.__earlyAtcInstalled) return;
      this.__earlyAtcInstalled = true;

      const self = this;

      // CLICK on submit controls (capture)
      this.events.register(
        window,
        'click',
        function (e) {
          const btn =
            e.target && e.target.closest ? e.target.closest('button[type="submit"], input[type="submit"]') : null;
          if (!btn || !btn.form) return;
          const form = btn.form;
          if (!self._isProductAddForm(form)) return;
          self._handleAddTrigger(e, form, btn);
        },
        { capture: true }
      );

      // KEYDOWN Enter (capture)
      this.events.register(
        window,
        'keydown',
        function (e) {
          if (e.key !== 'Enter') return;
          const el = e.target;
          if (!el || el.tagName === 'TEXTAREA' || el.isContentEditable === true) return;
          const form = el.closest ? el.closest('form') : null;
          if (!self._isProductAddForm(form)) return;
          const submitter = form.querySelector('button[type="submit"], input[type="submit"]');
          self._handleAddTrigger(e, form, submitter);
        },
        { capture: true }
      );

      // SUBMIT fallback (capture)
      this.events.register(
        window,
        'submit',
        function (e) {
          const form = e.target && e.target.closest ? e.target.closest('form') : null;
          if (!self._isProductAddForm(form)) return;
          const submitter = typeof e.submitter !== 'undefined' ? e.submitter : null;
          self._handleAddTrigger(e, form, submitter);
        },
        { capture: true }
      );
    }

    _setEmpireSpinner(btn, on) {
      if (!btn) return;
      if (on) {
        btn.classList.add('processing');
        btn.setAttribute('aria-busy', 'true');
      } else {
        btn.classList.remove('processing');
        btn.removeAttribute('aria-busy');
      }
    }

    async _ajaxAdd(form) {
      try {
        const fd = new FormData(form);
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: fd,
          credentials: 'same-origin',
          signal: this.controller.signal,
        });

        const json = await res.json();

        if (!res.ok) {
          const msg = json.description || json.message || 'Unable to add to cart.';
          new window.Empire.MessageBanner(msg, 'error');

          // On a 422 error, the QTY may have changed, so we continue to refresh
          if (res.status !== 422) {
            return false;
          }
        }

        await this.refresh();
        return true;
      } catch (err) {
        if (err.name !== 'AbortError') {
          console.error('[CartDrawer] add error', err);
          new window.Empire.MessageBanner('Something went wrong. Please try again.', 'error');
        }
        return false;
      }
    }

    _handleAddTrigger(e, form, submitter) {
      if (e) {
        e.preventDefault();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        e.stopPropagation();
      }

      if (form.__earlyAtcInFlight) return;
      form.__earlyAtcInFlight = true;

      // Spinner on (no disabling)
      this._setEmpireSpinner(submitter, true);

      const finalize = () => {
        this._setEmpireSpinner(submitter, false);
        form.__earlyAtcInFlight = false;
      };

      Promise.resolve(this._ajaxAdd(form))
        .then((ok) => {
          if (ok) this.open();
        })
        .then(finalize, finalize);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    window.Empire.sections.register('cart-drawer', (section) => new CartDrawerSection(section));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-header"]) return;
  try {
    
  const tabGroups = document.querySelectorAll('[role="tablist"]');
  const breakpoint = window.matchMedia('(min-width: 1024px)');

  tabGroups.forEach((group) => {
    const tabs = group.querySelectorAll('.main-menu-switcher');

    const initialTab = group.querySelector('.main-menu-switcher[aria-selected="true"]');

    const switchTabs = (el) => {
      tabs.forEach((tab) => {
        tab.setAttribute('aria-selected', 'false');
        tab.setAttribute('tabindex', '0');
      });

      el.setAttribute('aria-selected', 'true');
      el.setAttribute('tabindex', '-1');
    };

    const switchTheme = (el) => {
      const targetSelector = el.dataset?.target;
      const targetEl = targetSelector ? document.querySelector(targetSelector) : null;

      if (targetEl) {
        targetEl.classList.toggle('alternative-theme');
      } else {
        document.body.classList.toggle('alternative-theme');
      }
    };

    const focusTab = (currentTab, direction) => {
      const tabArray = Array.from(tabs);
      const currentIndex = tabArray.indexOf(currentTab);

      if (currentIndex === -1) return;

      const newIndex =
        direction === 'next'
          ? (currentIndex + 1) % tabArray.length
          : (currentIndex - 1 + tabArray.length) % tabArray.length;

      const newTab = tabArray[newIndex];
      switchTabs(newTab);
      switchTheme(newTab);
      newTab.focus();
    };

    const activateInitialTab = () => {
      if (!initialTab) return;

      const currentTab = group.querySelector('.main-menu-switcher[aria-selected="true"]');

      if (currentTab === initialTab) return;

      switchTabs(initialTab);
      switchTheme(initialTab);
    };

    tabs.forEach((el) => {
      el.addEventListener('click', () => {
        if (el.getAttribute('aria-selected') === 'false') {
          switchTabs(el);
          switchTheme(el);
        }
      });

      el.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          focusTab(el, 'next');
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          focusTab(el, 'prev');
        }
      });
    });

    group.activateInitialTab = activateInitialTab;
  });

  let wasDesktop = breakpoint.matches;

  const handleBreakpointChange = (event) => {
    if (event.matches !== wasDesktop) {
      tabGroups.forEach((group) => {
        if (typeof group.activateInitialTab === 'function') {
          group.activateInitialTab();
        }
      });

      wasDesktop = event.matches;
    }
  };

  breakpoint.addEventListener('change', handleBreakpointChange);

  } catch(e) { console.error(e); }
})();
})();
